
export default "/assets/arrow-uturn-left-micro.fe3da5e4.svg"